import React, { HTMLProps } from 'react';
import clsx from 'clsx';
import './style.scss';
import IconChecked from './icon-checked.svg';
import IconNotChecked from './icon-not-checked.svg';

export interface ICheckbox extends HTMLProps<HTMLInputElement> {
    className?: string
}

export const Checkbox: React.FC<ICheckbox> = (props): JSX.Element => {
    const {
        className = '',
        ...inputProps
    } = props;

    return (
        <div
            className={clsx(
                'oms-checkbox',
                {
                    'oms-checkbox-checked': inputProps.checked,
                    'oms-checkbox-disabled': inputProps.disabled
                },
                className
            )}
        >
            <label>
                <input {...inputProps} type="checkbox" />
                {inputProps.checked && (
                    <IconChecked />
                )}
                {!inputProps.checked && (
                    <IconNotChecked />
                )}
            </label>
        </div>
    );
};
